/**
 * Used to transform string currency to number
 * i.g 1,000 to 1000
 * */
export function currencyToNum(value: unknown): number | unknown {
  if (typeof value === 'string') {
    return Number(value.split(',').join(''))
  } else return value
}
